import {ref, computed, watch} from '@vue/composition-api'
import {useToast} from 'vue-toastification/composition'
import ToastificationContent
  from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import ability from '@/libs/acl/ability'
import {debounce} from 'lodash';
import useFilterCounter from '@/components/Filters/useFiltersCount';
import moment from "moment";

export default function useList() {
  const refListTable = ref(null)
  const toast = useToast()

  const tableColumns = [
    {
      label: 'intelbras.event_code',
      key: 'code'
    },
    {
      label: 'intelbras.alarm_type_sbo',
      key: 'type_alarm'
    },
    {
      label: 'intelbras.description',
      key: 'description'
    },
    {
      label: 'intelbras.zones_pgm',
      key: 'zones_pgm',
      formatter: (value, key, item) => {
        return !item.partition
          ? item.zone
          : item.partition;
      }
    },
    {
      label: 'intelbras.channel',
      key: 'channel'
    },
    {
      label: 'intelbras.num_conact_id',
      key: 'contact_id_number'
    },
    {
      label: 'intelbras.name_panel',
      key: 'panel'
    },
    {
      label: 'intelbras.creation_date',
      key: 'event_created_at',
      formatter: (value, _, item) => {
        return moment.utc(value).tz(item.time_zone).format('YYYY-MM-DD HH:mm:ss')
      }
    },
  ];

  const perPage = ref(10)
  const totalList = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)

  store.dispatch('type_alarm/getAll')
  store.dispatch('intelbras_events/getAll')
  store.dispatch('intelbras_panels/getAll')

  const eventCode = ref([])
  const eventCodeOptions = computed(() => store.getters['intelbras_events/getSelectedItems'])

  const typeAlarm = ref([])
  const alarmTypeOptions = computed(() => store.getters['type_alarm/getSelectedItems'])

  const panels = ref([])
  const panelOptions = computed(() => store.getters['intelbras_panels/getSelectedItems'])

  const startDatetimeFilter = ref(null)
  const endDatetimeFilter = ref(null)
  const eventCodeFilter = ref(null)
  const typeAlarmFilter = ref(null)
  const panelFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    }
  })

  const refetchData = () => {
    refListTable.value.refresh()
  }

  watch([currentPage, perPage], refetchData)
  watch([searchQuery], debounce(refetchData, 500))

  const fetchList = (ctx, callback) => {
    store.dispatch('intelbras_alarms/getAll', {
      q: searchQuery.value,
      max: perPage.value,
      'page[n]': currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      id_type_alarm: typeAlarmFilter.value,
      code: eventCodeFilter.value,
      id_panel: panelFilter.value,
      start_date: startDatetimeFilter.value,
      end_date: endDatetimeFilter.value,
    })
      .then(response => {
        callback(response.data)
        totalList.value = response.meta.total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error obteniendo la información',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // filters counter ============================
  const filters = ref({});
  const filtersCount = useFilterCounter(filters);
  const buildFilters = () => {
    filters.value = {
      code: eventCodeFilter.value,
      id_type_alarm: typeAlarmFilter.value,
      id_panel: panelFilter.value,
      start_date: startDatetimeFilter.value,
      end_date: endDatetimeFilter.value
    }
    refetchData();
  }
  const clearSearchFilters = () => {
    eventCodeFilter.value = null;
    typeAlarmFilter.value = null;
    panelFilter.value = null;
    startDatetimeFilter.value = null;
    endDatetimeFilter.value = null;

    buildFilters();
  }
  // ============================================


  return {
    tableColumns,
    perPage,
    currentPage,
    totalList,
    fetchList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,
    refetchData,

    eventCode,
    eventCodeOptions,
    typeAlarm,
    alarmTypeOptions,
    panels,
    panelOptions,
    startDatetimeFilter,
    endDatetimeFilter,
    eventCodeFilter,
    typeAlarmFilter,
    panelFilter,

    filtersCount,
    buildFilters,
    clearSearchFilters,

  }
}
